/**
 * Teaser Banner — CTA <button> navigates via data attributes (no anchor wrapper).
 */
(function initLvzTeaserBanner() {
	/**
	 * @param {HTMLButtonElement} button
	 */
	function navigate(button) {
		const href = button.getAttribute('data-lvz-teaser-href');
		const target = button.getAttribute('data-lvz-teaser-target') || '_self';
		if (!href) {
			return;
		}
		if (target === '_blank') {
			window.open(href, '_blank', 'noopener,noreferrer');
		} else {
			window.location.assign(href);
		}
	}

	/**
	 * @param {HTMLButtonElement} button
	 */
	function initOne(button) {
		button.addEventListener('click', function onTeaserCtaClick(e) {
			e.preventDefault();
			navigate(button);
		});
	}

	function boot() {
		document.querySelectorAll('[data-lvz-teaser-cta]').forEach(function (el) {
			initOne(el);
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', boot);
	} else {
		boot();
	}
})();
